import { render, staticRenderFns } from "./ComContainer.vue?vue&type=template&id=cb339234&"
import script from "./ComContainer.vue?vue&type=script&lang=js&"
export * from "./ComContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports